import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomQueryService } from './dom-query.service';

@NgModule({
  providers: [DomQueryService],
  imports: [CommonModule],
})
export class DomQueryModule {}
